module.exports = __webpack_public_path__ + "img/Bot-Twitter.f7927752.png";